export const hourlyRequestBasecaseLabelSuffixes: Record<string, string> = {
  plt26_ttf12_8: 'central',
  plt26_ttf10_6: 'low',
  plt26_ttf10_8: 'high',
};

export const pmfHourlyRequestBasecaseNames: string[] = ['plt26_ttf12_8', 'plt26_ttf12_6', 'plt26_ttf10_8'];
